import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/creator/perks.webp")